export default "__VITE_ASSET__XWzl4GAm__"